import { RevealBlock } from "./motion";
import { Plane, TrainFront, Hotel, Building2, GraduationCap, HeartPulse } from "lucide-react";

const LOCATIONS = [
  { icon: Plane,         t: "Airports & terminals", d: "Gate lounges, transit corridors, arrivals and airside precincts." },
  { icon: HeartPulse,    t: "Hospitals & clinics",  d: "Patient areas, staff zones and 24-hour foyers." },
  { icon: GraduationCap, t: "Campuses & student living", d: "Libraries, student hubs, residential common areas and after-hours study spaces." },
  { icon: Building2,     t: "Workplaces & offices", d: "Reception areas, breakout zones and corporate wellness floors." },
  { icon: TrainFront,    t: "Transport hubs",       d: "Rail stations, coach terminals and interchange points." },
  { icon: Hotel,         t: "Accommodation & hotels", d: "Student residences, lobbies, gyms and shared community spaces." },
];

const IMG = "/machine.png";

export default function Locations() {
  return (
    <section id="locations" className="relative bg-ink py-16 md:py-24 border-t border-white/8" data-testid="locations-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid grid-cols-12 gap-8 md:gap-10 items-start">
        <div className="col-span-12 lg:col-span-5">
          <RevealBlock>
            <p className="eyebrow mb-3">Locations</p>
            <h2 className="font-display font-light text-bone text-3xl sm:text-4xl md:text-5xl leading-[1.05] tracking-tight">
              Built for airports.<br /><span className="text-orange">Adaptable beyond them.</span>
            </h2>
            <div className="mt-5 gold-rule" />
            <p className="mt-6 text-bone/70 text-base leading-relaxed max-w-md font-sans">
              Airports are our priority environment: early departures, long connections and forgotten essentials create a clear need for convenient 24/7 access. The same managed format can also serve other high-traffic locations.
            </p>
          </RevealBlock>

          <RevealBlock delay={0.15} className="mt-8 relative aspect-[4/3] w-full overflow-hidden rounded-2xl bg-ink2 border border-white/8">
            <img src={IMG} alt="MinisRus machine in a public space" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent" />
          </RevealBlock>
        </div>

        <div className="col-span-12 lg:col-span-7 grid sm:grid-cols-2 gap-4 md:gap-5">
          {LOCATIONS.map((l, i) => {
            const Icon = l.icon;
            return (
              <RevealBlock
                key={l.t}
                delay={i * 0.05}
                y={20}
                className="card-lift bg-ink2 border border-white/8 rounded-xl p-5 md:p-6 flex flex-col h-full"
                data-testid={`location-${l.t.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`}
              >
                <div className="flex items-start justify-between">
                  <div className="w-11 h-11 rounded-full bg-orange/15 flex items-center justify-center">
                    <Icon size={19} strokeWidth={1.7} className="text-orange" />
                  </div>
                  <span className="text-orange/80 text-[13px] font-semibold tracking-normal font-sans tabular-nums">{String(i + 1).padStart(2, '0')}</span>
                </div>
                <h3 className="mt-5 font-semibold text-bone text-lg leading-tight">{l.t}</h3>
                <p className="mt-1.5 text-bone/60 text-sm leading-relaxed">{l.d}</p>
              </RevealBlock>
            );
          })}
        </div>
      </div>
    </section>
  );
}
